export default class State {
  is_auth = false;
}
